define("shared/utils/constants/linkinbio-block-types", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  var BlockTypes;

  (function (BlockTypes) {
    BlockTypes["App"] = "app";
    BlockTypes["ButtonList"] = "button_list";
    BlockTypes["FeaturedBanner"] = "featured_banner";
    BlockTypes["FeaturedMedia"] = "featured_media";
    BlockTypes["Feed"] = "feed";
    BlockTypes["FeedList"] = "feed_list";
    BlockTypes["Gallery"] = "gallery";
    BlockTypes["Header"] = "header";
    BlockTypes["SocialLinkList"] = "social_link_list";
    BlockTypes["Style"] = "style";
  })(BlockTypes || (BlockTypes = {}));

  var _default = BlockTypes;
  _exports.default = _default;
});